import React from 'react';
import {resolveAppearance} from '../utils/uiUtils';
import {IconArrowRight, IconTrash} from "@tabler/icons-react";
import {Screen} from '../types';

interface ScreenDataTableActionsProps {
    screen: Screen;
    row: any;
    isDeleting: boolean;
    showUpdateDropdown: string | number | null;
    setShowUpdateDropdown: (id: string | number | null) => void;
    onWorkflowClick: (button: any, row: any, e: React.MouseEvent) => void;
    onUpdateClick: (row: any, form: any, e: React.MouseEvent) => void;
    onDeleteClick: (row: any, e: React.MouseEvent) => void;
}

export const ScreenDataTableActions: React.FC<ScreenDataTableActionsProps> = ({
    screen,
    row,
    isDeleting,
    showUpdateDropdown,
    setShowUpdateDropdown,
    onWorkflowClick,
    onUpdateClick,
    onDeleteClick
}) => {
    // Only row-level buttons render per row; screen-level buttons live in the header.
    const rowButtons = (screen.buttons || []).filter((b) => b.type !== 'screen');

    if (!screen.updateForms?.length && !screen.deleteEnabled && rowButtons.length === 0) {
        return null;
    }

    return (
        <td className="actions-cell">
            <div className="d-flex gap-1 justify-content-end align-items-center">
                {rowButtons.length > 0 && (
                    rowButtons
                        .sort((a, b) => a.sortOrder - b.sortOrder)
                        .map((button) => (
                            <button
                                key={button.id || button.url}
                                data-e2e={`btn:${button.id || button.url}`}
                                className={`btn btn-sm text-nowrap ${resolveAppearance(button.appearance, 'button').className || 'btn-outline-primary'}`}
                                style={resolveAppearance(button.appearance, 'button').style}
                                onClick={(e) => onWorkflowClick(button, row, e)}
                                title={button.displayName}
                            >
                                {button.displayName}
                            </button>
                        ))
                )}
                {screen.updateForms && screen.updateForms.length > 0 && (
                    screen.updateForms.length === 1 ? (
                        <button
                            type="button"
                            data-e2e={`detail:${row.id}`}
                            className="v5-iconact is-primary"
                            onClick={(e) => onUpdateClick(row, screen.updateForms[0], e)}
                            title="Detail"
                        >
                            <IconArrowRight stroke={1.75} size={14}/>
                        </button>
                    ) : (
                        <div className="dropdown">
                            <button
                                type="button"
                                className="v5-iconact is-primary"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setShowUpdateDropdown(showUpdateDropdown === row.id ? null : row.id);
                                }}
                                title="Detail"
                            >
                                <IconArrowRight stroke={1.75} size={14}/>
                            </button>
                            {showUpdateDropdown === row.id && (
                                <div className="dropdown-menu show"
                                     style={{position: 'absolute'}}>
                                    {screen.updateForms.map((form: any) => (
                                        <button
                                            key={form.id}
                                            data-e2e={`detail:${row.id}:${form.id}`}
                                            className="dropdown-item"
                                            onClick={(e) => onUpdateClick(row, form, e)}
                                        >
                                            {form.displayName}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    )
                )}
                {screen.deleteEnabled && (
                    <button
                        type="button"
                        data-e2e={`delete:${row.id}`}
                        className="v5-iconact is-danger delete-icon"
                        onClick={(e) => onDeleteClick(row, e)}
                        disabled={isDeleting}
                        title="Vymazať"
                    >
                        {isDeleting ? (
                            <span className="spinner-border spinner-border-sm"
                                  role="status"></span>
                        ) : (
                            <IconTrash stroke={2} size={15}/>
                        )}
                    </button>
                )}
            </div>
        </td>
    );
};
